import * as Utils from "../Utils";

const getAuthToken = () => localStorage.getItem("adminToken");

/** Normalize dashboard filter values before sending to analytics API. */
export const normalizeAnalyticsFilter = (filter) => {
  if (!filter || typeof filter !== "string") {
    return "last30days";
  }

  const key = filter.trim().toLowerCase().replace(/[\s_-]+/g, "");

  const aliases = {
    today: "today",
    last7days: "last7days",
    last7day: "last7days",
    last30days: "last30days",
    last30day: "last30days",
    thisyear: "thisYear",
    year: "thisYear",
    all: "all",
    alltime: "all",
  };

  return aliases[key] || filter;
};

const parseJsonResponse = async (response) => {
  try {
    return await response.json();
  } catch {
    return {};
  }
};

const analyticsRequest = async (path, params = {}) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      query.append(key, value);
    }
  });

  const queryPart = query.toString() ? `?${query.toString()}` : "";
  const response = await fetch(`${Utils.API_URL}analytics/${path}${queryPart}`, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${getAuthToken()}`,
    },
  });

  const data = await parseJsonResponse(response);

  if (!response.ok) {
    const error = new Error(data?.message || `Analytics request failed (${response.status})`);
    error.response = data;
    error.status = response.status;
    throw error;
  }

  return data;
};

/**
 * GET /api/analytics/summary
 * @param {string} filter - today | last7days | last30days | thisYear | all
 */
export async function getDashboardSummary(filter) {
  const normalized = normalizeAnalyticsFilter(filter);
  return analyticsRequest("summary", normalized ? { filter: normalized } : {});
}

/**
 * GET /api/analytics/charts
 * @param {string} interval - daily | weekly | monthly
 * @param {string} [filter] - optional time filter
 */
export async function getChartAnalytics(interval, filter) {
  const params = {};
  if (interval) params.interval = interval;
  if (filter) params.filter = normalizeAnalyticsFilter(filter);
  return analyticsRequest("charts", params);
}
